import { NodeType } from "../NodeType";

export {
  defaultWebhookTriggerNode,
  WebhookPayloadFormat,
  WebhookPayloadMappingTarget,
  TWebhookTriggerNode,
  TWebhookTriggerNodeConfig,
  TWebhookPayloadMapping,
  TWebhookAuthSettings,
  IWebhookAuthSettingsApiKey,
  IWebhookAuthSettingsBearer,
  IWebhookAuthSettingsHmac,
  IWebhookAuthSettingsNone,
};

const defaultWebhookTriggerNode = {
  name: "Webhook",
  description: "",
  type: "webhook_trigger",
  expectedPayloadFormat: "JSON",
  payloadMapping: [],
  authSettings: {
    authType: "none",
  },
} as const;

const WebhookPayloadFormat = {
  JSON: "JSON",
  XML: "XML",
  FORM_DATA: "Form Data",
} as const;

const WebhookPayloadMappingTarget = {
  CONTACT_FIELD: "contactField",
  ATTRIBUTE: "attribute",
} as const;

const WebhookAuth = {
  NONE: "none",
  API_KEY: "api_key",
  HMAC: "hmac",
  BEARER_TOKEN: "bearer_token",
};

type TWebhookTriggerNode = {
  nodeId: string;
  type: typeof NodeType.WEBHOOK_TRIGGER;
  name: string;
  description?: string;
  config: TWebhookTriggerNodeConfig;
};

type TWebhookTriggerNodeConfig = {
  name: string;
  description?: string;
  webhookId: string;
  expectedPayloadFormat: typeof WebhookPayloadFormat;
  payloadMapping: Array<TWebhookPayloadMapping>;
  authSettings: TWebhookAuthSettings;
  deduplicationField?: string;
  responseConfig?: {
    successMessage?: string;
    statusCode?: number;
  };
};

type TWebhookPayloadMapping = {
  sourceField: string;
  targetField: string;
  targetType: typeof WebhookPayloadMappingTarget;
  isRequired: boolean;
  defaultValue?: string;
};

type TWebhookAuthSettings =
  | IWebhookAuthSettingsNone
  | IWebhookAuthSettingsApiKey
  | IWebhookAuthSettingsBearer
  | IWebhookAuthSettingsHmac;

interface IWebhookAuthSettingsNone {
  authType: typeof WebhookAuth.NONE;
}

interface IWebhookAuthSettingsApiKey {
  authType: typeof WebhookAuth.API_KEY;
  apiKeyHeader: string;
  apiKeyValue: string;
}

interface IWebhookAuthSettingsHmac {
  authType: typeof WebhookAuth.HMAC;
  hmacSecret: string;
  hmacHeader: string;
}

interface IWebhookAuthSettingsBearer {
  authType: typeof WebhookAuth.BEARER_TOKEN;
  bearerToken: string;
}
